export default __webpack_public_path__ + "static/1-lower-mainland-label-abe843848ea5865a446a8c65181e10ea.svg";